import React, { useEffect } from "react";

import useScript from "helpers/use_script";
import "./style.module.css";

const HEADWAYAPP_ACCOUNT = "yEAn2y";
const HEADWAYAPP_SELECTOR = "#headwayapp-button";

export default function Headwayapp() {
  useScript("https://cdn.headwayapp.co/widget.js");
  const isLoaded = window.Headway && window.Headway.init;

  const config = {
    account: HEADWAYAPP_ACCOUNT,
    selector: HEADWAYAPP_SELECTOR,
    trigger: HEADWAYAPP_SELECTOR,
    position: { x: "right", y: "top" },
  };

  useEffect(() => {
    if (isLoaded) {
      window.Headway.init(config);
    }
  }, [isLoaded]);

  return (
    <a
      id="headwayapp-button"
      href={isLoaded ? "#" : "https://changelog.testerwork.com/"}
      target="_blank"
      className="items-center justify-between text-muted hover:text-muted flex focus:text-muted focus:no-underline"
    >
      News
    </a>
  );
}
